import { SVGProps, Ref, forwardRef } from 'react';

export const ATSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M0 8a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v4H0z" fill="#ED2939" />
        <path d="M0 20h32v4a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" fill="#ED2939" />
        <path d="M0 12h32v8H0z" fill="#EEEEEE" />
    </svg>
));
ATSize32Glyph.displayName = 'ATSize32Glyph';
